import type { RouteObject } from 'react-router';
import { RequirePermission } from '@/lib/auth';
import { lazyNamed } from '@/lib/lazy';

const SerialsPage = lazyNamed(() => import('./pages'), 'SerialsPage');
const SerialDetailPage = lazyNamed(() => import('./pages'), 'SerialDetailPage');

/**
 * Staff routes for features/serials. Paths are relative to /staff. Replace a placeholder by building the page in this folder
 * and pointing the lazy import at it; keep the permission wrapper.
 */
export const serialsRoutes: RouteObject[] = [
  { path: 'serials', element: <RequirePermission permission={['serials']}><SerialsPage /></RequirePermission> },
  { path: 'serials/:id', element: <RequirePermission permission={['serials']}><SerialDetailPage /></RequirePermission> },
];
